<template>
  <div class="max-w-lg">
    <h1 class="text-lg font-bold mb-5">Хэрэглэгчийн бүртгэл</h1>
    <div v-if="loading">loading</div>
    <div v-else-if="item">
      <my-input v-model="item.lastName" required label="Овог" />
      <my-input v-model="item.firstName" required label="Нэр" />
      <my-input v-model="item.email" required label="И-Мейл хаяг" />
      <my-input v-model="item.username" required label="Нэвтрэх нэр" />
      <my-select v-model="item.role" required :options="roles" label="Хандах эрх" />
      <div class="p-5 space-x-4">
        <my-button v-if="item && item.id" :loading="reseting" type="success" icon="key" @click="handleResetPassword">Нууц үг сэргээх</my-button>
        <my-button :loading="saving" type="primary" icon="check" @click="handleSave">Хадгалах</my-button>
        <my-button icon="x" @click="handleBack">Буцах</my-button>
      </div>
    </div>
    <div v-else>
      <my-alert>Системд ямар нэгэн алдаа гарлаа</my-alert>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      reseting: false,
      loading: false,
      saving: false,
      temp: {
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        role: null
      },
      item: null,
      roles: []
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  created () {
    this.getRoles()
    this.handleRefresh()
  },
  methods: {
    async getRoles () {
      try {
        this.roles = (await this.axios.get('/roles')).data
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleResetPassword () {
      try {
        this.reseting = true
        await this.axios.get(`/users/resetPassword/${this.id}`)
        this.showToast('Нууц үгийг амжилттай сэргээлээ.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.reseting = false
      }
    },
    async handleRefresh () {
      try {
        this.loading = true
        if (this.id === 'create') {
          this.item = Object.assign({}, this.temp)
        } else {
          this.item = (await this.axios.get(`users/${this.id}`)).data
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    handleBack () {
      this.$router.back()
    },
    async handleSave () {
      try {
        const checkRequireKeys = ['firstName', 'lastName', 'username', 'email', 'role']
        for (const key of checkRequireKeys) {
          if (!this.item[key]) {
            this.customError('Талбаруудыг гүйцэт бөглөнө үү.')
          }
        }
        await this.showConfirm({ message: 'Бүртгэлийг хадгалахдаа итгэлтэй байна уу?' })
        if (this.saving) return
        this.saving = true
        const data = (await this.axios.post('users', this.item)).data
        if (!this.item.id) {
          this.$router.replace({ name: 'users-detail', params: { id: data.id } })
        }
        this.showToast('Амжилттай хадгаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
